import PropTypes from 'prop-types';
import DefaultTemplate from '../Default/DefaultTemplate';
import CardsBody from '../../../Blocks/Cards/CardsBody';

const iconMapping = {
  pdf: 'picture_as_pdf',
  jpg: 'image',
  jpeg: 'image',
  png: 'image',
  mp3: 'headphones',
  mp4: 'movie',
  default: 'docs',
};

const DownloadList = (props) => {
  if (props.displayAsCard) {
    const cards = props.items.map((item) => {
      const mimeTypeParts = item.mime_type?.split('/');
      const fileExtension = mimeTypeParts
        ? mimeTypeParts[mimeTypeParts.length - 1]
        : '';

      const icon = iconMapping[fileExtension] || iconMapping.default;

      return {
        title: item.title || item.id,
        description: item.description,
        href: [
          {
            '@id': `${item.getURL}/@@download/file`,
          },
        ],
        icon: icon,
        size: item.getObjSize || '',
      };
    });

    const data = {
      cards,
      cardsPerRow: 3,
      cardsPerRowOnMobile: 1,
      align: 'left',
      label: 'Download',
      style: 'icon-transparent-dark-blue',
    };
    return (
      <CardsBody data={data} isEditMode={props.isEditMode} isDownloadList />
    );
  }

  return <DefaultTemplate {...props} showDownloadButton />;
};

DownloadList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  linkMore: PropTypes.any,
  isEditMode: PropTypes.bool,
};

export default DownloadList;
